import AutoComplete from 'js-autocomplete';

const focusBox = document.querySelector('.focus-box');

focusBox.addEventListener('click', function (e) {
    this.classList.add('opened');
});

document.addEventListener('click', (e) => {
    if (!e.target.closest('.focus-box')) {
        focusBox.classList.remove('opened');
    }
});

if (document.querySelector('.search-tags')) {
    document.querySelector('body').classList.add('tags-enabled');
}

if (document.querySelector('.toggle-categories')) {
    document.querySelector('.toggle-categories').addEventListener('click', () => {
        document.querySelector('.toggle-categories').classList.toggle('tags-visible');
        document.querySelector('.search-tags').classList.toggle('visible');
    });
    document.querySelector('.toggle-categories').addEventListener('mouseenter', () => {
        document.querySelector('.toggle-categories').classList.add('tags-visible');
        document.querySelector('.search-tags').classList.add('visible');
    });
    document.querySelector('.search-tags').addEventListener('mouseleave', () => {
        document.querySelector('.toggle-categories').classList.remove('tags-visible');
        document.querySelector('.search-tags').classList.remove('visible');
    });
}
if (document.querySelector('.close-categories')) {
    document.querySelector('.close-categories').addEventListener('click', () => {
        document.querySelector('.toggle-categories').classList.remove('tags-visible');
        document.querySelector('.search-tags').classList.remove('visible');
    });
}

let autocompleteObject;
function autocomplete() {
    autocompleteObject = new AutoComplete({
        selector: '#search',
        cache: false,
        minChars: 1,
        delay: 20,
        source(term, response) {
            const request = new XMLHttpRequest();
            const params = { query: term };
            const encodedParams = Object.keys(params).map((param) => `${encodeURIComponent(param)}=${encodeURIComponent(params[param])}`);
            let autocompleteUrl = document.getElementById('search').getAttribute('data-autocomplete');
            autocompleteUrl = autocompleteUrl.indexOf('?') === -1 ? `${autocompleteUrl}?` : `${autocompleteUrl}&`;
            request.open('GET', autocompleteUrl + encodedParams.join('&'), true);
            request.onload = function () {
                if (request.status >= 200 && request.status < 400) {
                    // Success!
                    response(JSON.parse(request.responseText));
                } else {
                    // We reached our target server, but it returned an error
                }
            };
            request.onerror = function () {
                // There was a connection error of some sort
            };
            request.send();
        },
        renderItem(item, search) {
            // escape special characters

            const searchSafe = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
            const re = new RegExp(`(.*?\\s|^)(${searchSafe})(.*)`, 'gi');
            return `<div class="autocomplete-suggestion" data-test="autocomplete-suggestion" data-val="${item}">${item.replace(re, '$1$2<em>$3</em>')}</div>`;
        },
        onSelect() {
            document.querySelector('#search_form_mini [type="submit"]').click();
        },
    });
}

autocomplete();
